import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { App } from 'antd';
import { UIMessage, NewVersionNotification } from 'Common/notifications';

const MessageDisplayer = () => {
  const intl = useIntl();
  const { message, notification } = App.useApp();

  useEffect(() => {
    const subscription = UIMessage.subscribe(({ topic, data }) => {
      const msg = intl.formatMessage(
        data.message,
        data.messageOptions?.values || {}
      );
      const options = data.messageOptions;
      if (message[topic]) {
        return message[topic]({ ...options, content: msg });
      }
      return message.info({ ...options, content: msg });
    });

    return () => subscription.unsubscribe();
  }, [intl, message]);

  useEffect(() => {
    const subscription = NewVersionNotification.subscribe(() => {
      notification.info({
        duration: 8,
        message: intl.formatMessage({
          defaultMessage: 'New version available',
        }),
        description: intl.formatMessage({
          defaultMessage: 'Please refresh the page to get the new content',
        }),
      } as any);
    });

    return () => subscription.unsubscribe();
  }, [intl, notification]);

  return null;
};

export default MessageDisplayer;
